import { CountryEnum } from "@/lib/supabase/supabaseEnums";
import { CitySelect } from "../../forms/form-input-components/selects/city-select/city-select";
import { CustomTextField } from "../../forms/form-input-components/custom-input-components/custom-text-field.component";
import { CitySelectShadcn } from "../../forms/form-input-components/selects/city-select/city-select-shadcn";
import { CustomTextFieldShadcn } from "../../forms/form-input-components/custom-input-components/custom-text-field-shadcn.component";
import { INVALID_CONTROL_CLASS } from "../input-wrapper";
import { hasSwissPostalCodes } from "@/dentlab/src/lib/utils/country-utils";

export const PostalCodeAndCityInputShadcn: React.FC<{
	country: CountryEnum;
	postalCodeValue: string;
	cityValue: string;
	onPostalCodeChange: (value: string) => void;
	onCityChange: (value: string) => void;
	required: boolean;
	disabled?: boolean;
	inputHeight?: number;
	/** Red border only; the message is rendered by the parent composite. */
	invalid?: boolean;
}> = ({
	country,
	postalCodeValue,
	cityValue,
	onPostalCodeChange,
	onCityChange,
	required,
	disabled,
	inputHeight,
	invalid = false,
}) => {
	const invalidClass = invalid ? INVALID_CONTROL_CLASS : undefined;
	return (
		<>
			{hasSwissPostalCodes(country) ? (
				<CitySelectShadcn
					onChange={(value) => {
						onPostalCodeChange(value.postalCode);
						onCityChange(value.city);
					}}
					value={postalCodeValue + " " + cityValue}
					required={required}
					disabled={disabled}
					inputHeight={inputHeight}
					className={invalidClass}
				/>
			) : (
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						gap: "8px",
					}}
				>
					<CustomTextFieldShadcn
						label="PLZ"
						value={postalCodeValue}
						onChange={(event) =>
							onPostalCodeChange(event.target.value)
						}
						required={required}
						disabled={disabled}
						inputHeight={inputHeight}
						classNameInput={invalidClass}
					/>
					<CustomTextFieldShadcn
						label="Ort"
						value={cityValue}
						onChange={(event) => onCityChange(event.target.value)}
						required={required}
						disabled={disabled}
						inputHeight={inputHeight}
						classNameInput={invalidClass}
					/>
				</div>
			)}
		</>
	);
};
